/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import {Component, Input, Output, EventEmitter} from "@angular/core";

declare var $: any;

@Component({
  selector: 'app-history-error-dialog',
  templateUrl: './history-error-dialog.component.html',
  styleUrls: ['./history-error-dialog.component.css']
})
export class HistoryErrorDialogComponent {
  @Input() historyError = "";

  constructor() {

  }

  public show(): void {
    $("#historyRequestErrorDialog").modal("show");
  }

  public hide(): void {
    $("#historyRequestErrorDialog").modal("hide");
  }

}
